import React from "react";
import { AmortizationSystem } from "../types/ownerDashboard.types";

interface AmortizationSystemToggleProps {
  value: AmortizationSystem;
  onChange: (value: AmortizationSystem) => void;
}

const OPTIONS: { value: AmortizationSystem; label: string; description: string }[] = [
  {
    value: "price",
    label: "Parcela fixa",
    description: "Informe a parcela mensal (Tabela Price)",
  },
  {
    value: "sac",
    label: "SAC",
    description: "Parcela decrescente com valor financiado",
  },
];

export default function AmortizationSystemToggle({
  value,
  onChange,
}: AmortizationSystemToggleProps) {
  return (
    <div className="flex w-full flex-col gap-1.5">
      <span className="text-[0.65rem] font-semibold uppercase tracking-wider text-[#6e7681]">
        Sistema de amortização
      </span>
      <div className="flex w-full flex-col gap-2 sm:flex-row">
        {OPTIONS.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`flex flex-1 flex-col items-start rounded-xl border px-3 py-2.5 text-left transition-colors ${
              value === option.value
                ? "border-[#6ea8ff]/50 bg-[#6ea8ff]/10"
                : "border-white/[0.08] bg-[#0d1117] hover:bg-white/[0.03]"
            }`}
          >
            <span
              className={`text-sm font-semibold ${
                value === option.value ? "text-[#6ea8ff]" : "text-[#f0f6fc]"
              }`}
            >
              {option.label}
            </span>
            <span className="mt-0.5 text-xs text-[#8b949e]">{option.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
